export const frontURL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
export const backURL = process.env.REACT_APP_API_URL || 'http://localhost:4444';
